module.exports = __webpack_public_path__ + "img/invoice-at-female.ff48cfb7.png";